import { FC, useEffect } from 'react';
import { useFormData } from '../context/FormDataContext';
import { FormActionType } from '../context/form-state-reducer';
import { TextField as TextFieldType } from '../../../interfaces/FormFieldTypes';
import { TextField } from '@dispatcher-stratus/stratus-react';
import { t } from 'i18next';
import { Typography } from '@material-ui/core';

interface Props {
  field: TextFieldType;
}

const GeneralTextField: FC<any> = ({ field }: Props) => {
  const { state, dispatch } = useFormData();
  const fieldError = state.errors.get(field.id);

  useEffect(() => {
    function validateField(): string {
      const { required, minLength, maxLength } = field.config;
      if (maxLength && field.value.length > field.config.maxLength)
        return t('Value cannot be longer than {{max}} characters.', {
          max: field.config.maxLength.toString(),
        });
      if (minLength && field.value.length < field.config.minLength)
        return t('Value cannot be shorter than {{min}} characters.', {
          min: field.config.minLength.toString(),
        });
      if (required && !field.value) return t('Cannot be empty');
      return '';
    }
    if (field.config.readonly) return; //skip validation if field is readonly
    const error = validateField();
    dispatch({
      type: FormActionType.SET_FORM_ERROR,
      payload: {
        id: field.id,
        message: error,
      },
    });
  }, [field, dispatch]);

  function handleChange(e: any) {
    dispatch({
      type: FormActionType.SET_FIELD_VALUE,
      payload: {
        id: field.id,
        value: e.target.value,
      },
    });
  }

  return (
    <TextField
      label={
        <Typography variant="body1" style={{ lineHeight: '1.2em' }}>
          {field.config.title}
          {field.config.required ? ' *' : ''}
        </Typography>
      }
      fullWidth
      type={field.config.mask ? 'password' : 'text'}
      key={field.id + '_field'}
      variant="outlined"
      size="small"
      value={field.value || ''}
      onChange={handleChange}
      error={!!fieldError}
      disabled={field.config.readonly}
      inputProps={{
        maxLength: 255,
      }}
      helperText={fieldError}
    />
  );
};

export default GeneralTextField;
